/* Layout 4 — desktop sticky add-to-cart (≥1024px) */
(function () {
  'use strict';

  var DESKTOP_MQ = window.matchMedia('(min-width: 1024px)');

  function isDesktop() {
    return DESKTOP_MQ.matches;
  }

  function init() {
    var bar = document.querySelector('[data-sticky-atc-desktop]');
    if (!bar) return;

    var sectionId = bar.dataset.sectionId;
    var SCOPE = '#ProductSection-' + sectionId;
    var BTN_SEL = '[data-add-to-cart]';
    var QTY_SEL = '.pf-qty-input[data-quantity-input]';
    var VARIANT_ID_SEL = 'input[name="id"]';
    var MASTER_SEL = 'select#ProductSelect-' + sectionId;
    var PREORDER_SEL = '.pre-oder-custom';

    var badge = bar.querySelector('[data-sticky-atc-badge]');
    var badgeText = bar.querySelector('[data-sticky-atc-badge-text]');
    var submitBtn = bar.querySelector('[data-sticky-atc-submit]');
    var variantIdInput = bar.querySelector('[data-sticky-atc-variant-id]');
    var variantLabel = bar.querySelector('[data-sticky-atc-variant-label]');
    var variantTrigger = bar.querySelector('[data-sticky-atc-variant-trigger]');
    var variantList = bar.querySelector('[data-sticky-atc-variant-list]');
    var variantWrap = bar.querySelector('[data-sticky-atc-variant-wrap]');
    var priceWrap = bar.querySelector('[data-sticky-atc-price-wrap]');
    var imageEl = bar.querySelector('[data-sticky-atc-image]');
    var qtyInput = bar.querySelector('[data-sticky-atc-qty-input]');
    var form = document.getElementById('form-sticky-desktop');

    var labels = {
      stock: {
        instock: badge && badge.dataset.labelInstock,
        preorder: badge && badge.dataset.labelPreorder,
        outofstock: badge && badge.dataset.labelOutofstock
      },
      btn: {
        instock: submitBtn && submitBtn.dataset.labelInstock,
        preorder: submitBtn && submitBtn.dataset.labelPreorder,
        outofstock: submitBtn && submitBtn.dataset.labelOutofstock
      }
    };

    var productCache = null;
    var qty = 1;
    var visibilityObserver = null;

    function scopedQ(sel) {
      var scope = document.querySelector(SCOPE) || document;
      return scope.querySelector(sel);
    }

    function getProductData() {
      if (productCache) return productCache;
      var el = document.getElementById('ProductJson-' + sectionId);
      if (!el || !el.textContent.trim()) return null;
      try {
        productCache = JSON.parse(el.textContent.trim());
      } catch (e) {
        productCache = null;
      }
      return productCache;
    }

    function getVariantById(id) {
      if (!id) return null;
      var product = getProductData();
      if (!product || !product.variants) return null;
      var sid = String(id);
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === sid) return product.variants[i];
      }
      return null;
    }

    function getVariantIdFromPage() {
      var input = scopedQ(VARIANT_ID_SEL);
      if (input && input.value) return input.value;
      var master = scopedQ(MASTER_SEL);
      if (master && master.value) return master.value;
      if (variantIdInput && variantIdInput.value) return variantIdInput.value;
      return null;
    }

    function getPreOrderFromOption(el) {
      return el && el.getAttribute('data-pre-order') === 'true';
    }

    function getInventoryQty(variant) {
      if (!variant) return null;
      var id = String(variant.id);
      var arr = window.inven_array || {};
      if (Object.prototype.hasOwnProperty.call(arr, id)) {
        var n = parseInt(arr[id], 10);
        return isNaN(n) ? null : n;
      }
      if (variant.inventory_management == null || variant.inventory_management === undefined) {
        return null;
      }
      if (variant.inventory_quantity != null && !isNaN(variant.inventory_quantity)) {
        return parseInt(variant.inventory_quantity, 10);
      }
      return null;
    }

    function isMetafieldPreorderVariant(variant) {
      if (!variant) return false;
      var opt = bar.querySelector(
        '[data-sticky-atc-variant-option][data-variant-id="' + variant.id + '"]'
      );
      if (opt) return getPreOrderFromOption(opt);
      var product = getProductData();
      if (product && product.variants && product.variants.length === 1) {
        return bar.getAttribute('data-single-variant-preorder') === 'true';
      }
      return false;
    }

    /* Same rules as main PDP (theme.js _updateAddToCart + product-template.liquid) */
    function detectStateFromVariant(variant) {
      if (!variant) return detectStateFromDOM();

      if (isMetafieldPreorderVariant(variant)) return 'preorder';

      if (!variant.available) {
        if (variant.inventory_policy === 'continue') return 'preorder';
        return 'outofstock';
      }

      if (variant.inventory_management === null || variant.inventory_management === undefined) {
        return 'instock';
      }

      var stockQty = getInventoryQty(variant);
      if (stockQty === null) return 'instock';
      if (stockQty > 0) return 'instock';
      return 'preorder';
    }

    function detectStateFromDOM() {
      var id = getVariantIdFromPage();
      var variant = getVariantById(id);
      if (variant) {
        var opt = bar.querySelector('[data-sticky-atc-variant-option][data-variant-id="' + id + '"]');
        if (opt && getPreOrderFromOption(opt)) return 'preorder';
        return detectStateFromVariant(variant);
      }

      var mainBtn = scopedQ(BTN_SEL);
      if (mainBtn && (mainBtn.disabled || mainBtn.getAttribute('aria-disabled') === 'true')) {
        return 'outofstock';
      }

      if (scopedQ(PREORDER_SEL)) return 'preorder';

      return 'instock';
    }

    function getStateFromOption(el) {
      if (!el) return 'instock';
      if (getPreOrderFromOption(el)) return 'preorder';
      var id = el.getAttribute('data-variant-id');
      var variant = getVariantById(id);
      if (variant) return detectStateFromVariant(variant);
      var state = el.getAttribute('data-state');
      if (state) return state;
      if (el.getAttribute('data-available') === 'false') return 'outofstock';
      return 'instock';
    }

    function getStateFromVariantId(id) {
      var opt = bar.querySelector('[data-sticky-atc-variant-option][data-variant-id="' + id + '"]');
      if (opt) return getStateFromOption(opt);
      return detectStateFromVariant(getVariantById(id));
    }

    function formatPriceHtml(cents) {
      var existing = priceWrap && priceWrap.querySelector('.price-with-sar');
      if (existing) {
        var money = existing.querySelector('.money') || existing;
        var glyph = existing.querySelector('.price-with-sar__glyph');
        var amount = (cents / 100).toFixed(2);
        if (glyph) {
          return (
            '<span class="price-with-sar" dir="ltr" translate="no">' +
            '<span class="price-with-sar__glyph" aria-hidden="true">' +
            glyph.innerHTML +
            '</span>' +
            '<span class="money">' +
            amount +
            '</span></span>'
          );
        }
        return '<span class="money">' + amount + '</span>';
      }
      return (cents / 100).toFixed(2);
    }

    function applyState(state) {
      if (!badge || !submitBtn) return;

      badge.classList.remove(
        'sticky-atc-desktop__badge--instock',
        'sticky-atc-desktop__badge--preorder',
        'sticky-atc-desktop__badge--outofstock'
      );
      badge.classList.add('sticky-atc-desktop__badge--' + state);

      submitBtn.classList.remove(
        'sticky-atc-desktop__btn--instock',
        'sticky-atc-desktop__btn--preorder',
        'sticky-atc-desktop__btn--outofstock'
      );
      submitBtn.classList.add('sticky-atc-desktop__btn--' + state);

      if (badgeText) badgeText.textContent = labels.stock[state] || labels.stock.instock;
      submitBtn.textContent = labels.btn[state] || labels.btn.instock;
      submitBtn.disabled = state === 'outofstock';
    }

    function closeVariantList() {
      if (!variantList || !variantTrigger) return;
      variantList.hidden = true;
      variantTrigger.setAttribute('aria-expanded', 'false');
      if (variantWrap) variantWrap.classList.remove('is-open');
    }

    function openVariantList() {
      if (!variantList || !variantTrigger) return;
      variantList.hidden = false;
      variantTrigger.setAttribute('aria-expanded', 'true');
      if (variantWrap) variantWrap.classList.add('is-open');
    }

    function setActiveVariantOption(id) {
      bar.querySelectorAll('[data-sticky-atc-variant-option]').forEach(function (opt) {
        var active = String(opt.getAttribute('data-variant-id')) === String(id);
        opt.classList.toggle('is-active', active);
        opt.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function updateUIFromOption(opt) {
      if (!opt) return;

      var id = opt.getAttribute('data-variant-id');
      var state = getStateFromOption(opt);
      if (state === 'instock' && scopedQ(PREORDER_SEL)) state = 'preorder';
      var price = parseInt(opt.getAttribute('data-price'), 10);
      var title = opt.getAttribute('data-title') || '';
      var img = opt.getAttribute('data-image');

      if (variantIdInput) {
        variantIdInput.value = id;
        variantIdInput.setAttribute('data-pre-order', state === 'preorder' ? 'true' : 'false');
      }
      if (variantLabel) variantLabel.innerHTML = opt.innerHTML;
      if (imageEl && img) imageEl.src = img;
      if (priceWrap && !isNaN(price)) priceWrap.innerHTML = formatPriceHtml(price);

      setActiveVariantOption(id);
      applyState(state);
    }

    function syncVariantToMainForm(id) {
      var master = scopedQ(MASTER_SEL);
      var hidden = scopedQ(VARIANT_ID_SEL);

      if (master && String(master.value) !== String(id)) {
        master.value = id;
        if (window.jQuery) {
          window.jQuery(master).trigger('change');
        } else {
          master.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (hidden && String(hidden.value) !== String(id)) {
        hidden.value = id;
        hidden.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function selectVariant(id, fromMainForm) {
      var opt = bar.querySelector('[data-sticky-atc-variant-option][data-variant-id="' + id + '"]');
      if (opt) {
        updateUIFromOption(opt);
      } else {
        applyState(getStateFromVariantId(id));
        if (variantIdInput) variantIdInput.value = id;
        var variant = getVariantById(id);
        if (variant && priceWrap && variant.price != null) {
          priceWrap.innerHTML = formatPriceHtml(variant.price);
        }
      }

      if (!fromMainForm) syncVariantToMainForm(id);
      closeVariantList();
    }

    function syncFromPage() {
      var id = getVariantIdFromPage();
      if (!id) return;

      if (variantIdInput) variantIdInput.value = id;

      var opt = bar.querySelector('[data-sticky-atc-variant-option][data-variant-id="' + id + '"]');
      if (opt) {
        updateUIFromOption(opt);
      } else {
        applyState(getStateFromVariantId(id));
        var variant = getVariantById(id);
        if (variant && priceWrap && variant.price != null) {
          priceWrap.innerHTML = formatPriceHtml(variant.price);
        }
      }

      if (scopedQ(PREORDER_SEL)) applyState('preorder');

      var mainQty = scopedQ(QTY_SEL);
      if (mainQty && qtyInput) {
        qty = parseInt(mainQty.value, 10) || 1;
        qtyInput.value = qty;
      }
    }

    function syncQtyToMain(q) {
      qty = Math.max(1, q);
      if (qtyInput) qtyInput.value = qty;
      var mainQty = scopedQ(QTY_SEL);
      if (mainQty && parseInt(mainQty.value, 10) !== qty) {
        mainQty.value = qty;
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function showBar() {
      if (!isDesktop()) return;
      bar.removeAttribute('hidden');
      bar.setAttribute('aria-hidden', 'false');
      bar.classList.add('is-visible');
      document.body.classList.add('show_sticky-desktop');
      document.body.classList.add('show_sticky');
    }

    function hideBar() {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('show_sticky-desktop');
      document.body.classList.remove('show_sticky');
      closeVariantList();
    }

    function updateVisibilityFromScroll() {
      if (!isDesktop()) {
        hideBar();
        return;
      }

      var target = scopedQ(BTN_SEL) || scopedQ('.product-form__cart-submit.pf-btn-cart') || scopedQ('.product-form__cart-submit');
      if (!target) return;

      var rect = target.getBoundingClientRect();

      /* Show once main ATC has scrolled above the viewport */
      if (rect.bottom <= 0) {
        showBar();
      } else {
        hideBar();
      }
    }

    function initVisibility() {
      var target = scopedQ(BTN_SEL) || scopedQ('.product-form__cart-submit.pf-btn-cart') || scopedQ('.product-form__cart-submit');

      if (target && 'IntersectionObserver' in window) {
        visibilityObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!isDesktop()) {
                hideBar();
                return;
              }
              if (entry.isIntersecting) hideBar();
              else showBar();
            });
          },
          { root: null, threshold: 0, rootMargin: '-1px 0px 0px 0px' }
        );
        visibilityObserver.observe(target);
      }

      window.addEventListener('scroll', updateVisibilityFromScroll, { passive: true });
      window.addEventListener('resize', updateVisibilityFromScroll, { passive: true });

      updateVisibilityFromScroll();
      setTimeout(updateVisibilityFromScroll, 400);
      setTimeout(updateVisibilityFromScroll, 1200);
    }

    function bindVariantDropdown() {
      if (!variantTrigger || !variantList) return;

      variantTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (variantList.hidden) openVariantList();
        else closeVariantList();
      });

      bar.querySelectorAll('[data-sticky-atc-variant-option]').forEach(function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault();
          selectVariant(opt.getAttribute('data-variant-id'), false);
        });
      });

      document.addEventListener('click', function (e) {
        if (!variantWrap || variantWrap.contains(e.target)) return;
        closeVariantList();
      });
    }

    function bindQty() {
      var minus = bar.querySelector('[data-sticky-atc-qty-minus]');
      var plus = bar.querySelector('[data-sticky-atc-qty-plus]');

      if (minus) {
        minus.addEventListener('click', function () {
          syncQtyToMain((parseInt(qtyInput.value, 10) || 1) - 1);
        });
      }
      if (plus) {
        plus.addEventListener('click', function () {
          syncQtyToMain((parseInt(qtyInput.value, 10) || 1) + 1);
        });
      }
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          syncQtyToMain(parseInt(qtyInput.value, 10) || 1);
        });
      }

      var mainQty = scopedQ(QTY_SEL);
      if (mainQty) {
        mainQty.addEventListener('change', function () {
          qty = parseInt(mainQty.value, 10) || 1;
          if (qtyInput) qtyInput.value = qty;
        });
      }
    }

    function bindFormSubmit() {
      if (!form) return;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!isDesktop()) return;

        var mainBtn = scopedQ(BTN_SEL);
        if (mainBtn && !mainBtn.disabled) {
          syncQtyToMain(parseInt(qtyInput.value, 10) || 1);
          if (variantIdInput) {
            var id = variantIdInput.value;
            syncVariantToMainForm(id);
          }
          mainBtn.click();
        }
      });
    }

    function afterVariantStable(fn) {
      requestAnimationFrame(function () {
        requestAnimationFrame(fn);
      });
    }

    function bindVariantListener() {
      if (!window.jQuery) return false;

      var $ = window.jQuery;
      var $sec = $(SCOPE);
      if (!$sec.length) return false;

      var ns = 'variantChange.stickyAtcDesktop-' + sectionId;
      var priceNs = 'variantPriceChange.stickyAtcDesktop-' + sectionId;

      $sec.off(ns).on(ns, function (evt) {
        afterVariantStable(function () {
          syncFromPage();
        });
      });

      $sec.off(priceNs).on(priceNs, function () {
        afterVariantStable(function () {
          syncFromPage();
        });
      });

      return true;
    }

    function bindVariantFallbacks() {
      var root = document.querySelector(SCOPE);
      if (!root || root.dataset.stickyAtcDesktopBound) return;
      root.dataset.stickyAtcDesktopBound = '1';

      var optionSel = '.single-option-selector-' + sectionId + ', #ProductSelect-' + sectionId;

      root.addEventListener('change', function (ev) {
        if (!ev.target || !ev.target.matches || !ev.target.matches(optionSel)) return;
        if (!isDesktop()) return;
        afterVariantStable(function () {
          syncFromPage();
        });
      });
    }

    function onBreakpointChange() {
      if (!isDesktop()) {
        hideBar();
      } else {
        bar.removeAttribute('hidden');
        syncFromPage();
        updateVisibilityFromScroll();
      }
    }

    applyState(bar.dataset.initialState || 'instock');
    bindVariantDropdown();
    bindQty();
    bindFormSubmit();
    initVisibility();
    bindVariantFallbacks();
    bindVariantListener();

    if (!bindVariantListener()) {
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (bindVariantListener() || attempts >= 80) clearInterval(interval);
      }, 50);
    }

    if (DESKTOP_MQ.addEventListener) {
      DESKTOP_MQ.addEventListener('change', onBreakpointChange);
    } else if (DESKTOP_MQ.addListener) {
      DESKTOP_MQ.addListener(onBreakpointChange);
    }

    syncFromPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
